import { ContributionBreakdown } from './data';

export const currentYear = () => new Date().getFullYear();

export const contributionPercents = (contributionBreakdown: ContributionBreakdown) => {
  const { ytdContributions, futureContributions } = contributionBreakdown;

  const percents = [
    {
      percent: ytdContributions,
      indicatorColor: 'bmtVizNavy',
    },
  ];

  if (futureContributions) {
    percents.push({
      percent: futureContributions,
      indicatorColor: 'bmtVizBlue50',
    });
  }

  return percents;
};
